import React, { PureComponent } from "react";
import {
  PieChart,
  Pie,
  Sector,
  Cell,
  ResponsiveContainer,
  Tooltip
} from "recharts";

const data = [
  { name: "Monthly Airdrops", value: 24.4, colorImg: "chart/s1.png" },
  { name: "IFO", value: 20, colorImg: "chart/s2.png" },
  { name: "CETO Blockchain Family", value: 12.5, colorImg: "chart/s3.png" },
  { name: "Fertilizer Bag", value: 20, colorImg: "chart/s4.png" },
  { name: "CETO Bonds", value: 12.3, colorImg: "chart/s5.png" },
  { name: "Yield Farmimg", value: 4.0, colorImg: "chart/s6.png" },
  { name: "Community/Mktg.", value: 2.0, colorImg: "chart/s7.png" },
  { name: "Locked Liquidity", value: 2.0, colorImg: "chart/s8.png" },
  { name: "Team", value: 1.5, colorImg: "chart/s9.png" },
  { name: "Development", value: 1.3, colorImg: "chart/s10.png" }
];

const COLORS = [
  "#cba302",
  "#fdcd0b",
  "#7C6400",
  "#463800",
  "#FFE16A",
  "#A4A72D",
  "#E0E441",
  "#739F50",
  "#509F7E",
  "#4E5A00"
];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const CustomTooltip = ({ payload }) => {
  return (
    <div>
      <div
        style={{
          backgroundColor: "white",
          width: "10rem",
          fontFamily: "Poppins",
          padding: "0.3rem 0.9rem",
          borderRadius: "8px",
          display: "flex",
          justifyContent: "space-around"
        }}
      >
        <div style={{ flex: "0.25", textAlign: "left" }}>
          <span>
            <img src={payload?.[0]?.payload?.colorImg} alt="s1" />
          </span>
        </div>
        <div style={{ flex: "0.75", textAlign: "left" }}>
          <b>{payload?.[0]?.payload?.value} %</b>
          <span>
            <p>
              <small>{payload?.[0]?.payload?.name}</small>
            </p>
          </span>
        </div>
      </div>
    </div>
  );
};

export default class PieCharts extends PureComponent {
  static demoUrl =
    "https://codesandbox.io/s/pie-chart-with-customized-label-dlhhj";

  render() {
    let width = window.innerWidth > 1700 ? 640 : 540;
    let height = window.innerWidth > 1700 ? 490 : 400;
    let outr = window.innerWidth > 1700 ? 260 : 190;
    if (window.innerWidth < 1100) {
      width = 450;
      height = 320;
      outr = 150;
    }
    if (window.innerWidth < 800) {
      width = 350;
      height = 280;
      outr = 120;
    }
    if (window.innerWidth < 500) {
      width = 280;
      height = 250;
      outr = 100;
    }

    return (
      <ResponsiveContainer width="100%" height="100%">
        <PieChart width={width} height={height}>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            stroke="none"
            // label={renderCustomizedLabel}
            paddingAngle={0}
            outerRadius={outr}
            fill="#8884d8"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>
    );
  }
}
